import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";

const SearchComponent = (props) => {
  const { placeholder, className, onSearchChange = () => {}, ...rest } = props;
  const [selectedValue, setselectedValue] = useState(null);

  const changeHandler = (e) => {
    setselectedValue(e.target.value);
    onSearchChange(e.target.value);
  };
  return (
    <Form.Group className={className}>
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text className="search-icon-background">
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          className={`search-bar-new ${className}`}
          placeholder={placeholder}
          autoFocus
          type="text"
          value={selectedValue}
          onChange={(a) => {
            changeHandler(a);
          }}
          // onKeyDown={keyDown}s
        />
      </InputGroup>
    </Form.Group>
  );
};

export default SearchComponent;
